import { usePageTracking } from "@garther/ui/libs";
import { useLocation } from "@tanstack/react-router";

export const useAppPageTracking = () => {
  const location = useLocation();
  usePageTracking(location.pathname);
};
